import Employee from './Employee'
export class ApplyMassUpdatesRequest {
    Employee: Employee;
    Records: any[];
    MassUpdateEntityID: number;
    Columns: any[];
}

export default ApplyMassUpdatesRequest;